import { combineReducers, createAction } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import searchVideosReducer from './searchVideosSlice';
import latestVideosReducer from './latestVideosSlice';
import affinityReducer from './affinitySlice';
import cartReducer from './cartSlice';
import customerReducer from './customerSlice';
import attemptVideoReducer from './attemptVideoSlice';
import navigationReducer from './navigationSlice';
import agenticSearchReducer from './agenticSearchSlice';

const appReducer = combineReducers({
  auth: authReducer,
  search: searchVideosReducer,
  latest: latestVideosReducer,
  affinity: affinityReducer,
  cart: cartReducer,
  customer: customerReducer,
  attempt: attemptVideoReducer,
  navigation: navigationReducer,
  agentic: agenticSearchReducer,
});

// Every slice back to its initial state at once (28 Oct, item 3): the one sign-out (services/signOut.ts) dispatches it,
// so nothing of the person who signed out is left in this tab's store, whatever slices are added later.
export const resetAllState = createAction('app/resetAllState');

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: Parameters<typeof appReducer>[1]) =>
  appReducer(action.type === resetAllState.type ? undefined : state, action);

export default rootReducer;
